import de from '@translations/de/auth.json';
import en from '@translations/en/auth.json';
import pl from '@translations/pl/auth.json';
import sl from '@translations/sl/auth.json';
import uk from '@translations/uk/auth.json';
import bg from '@translations/bg/auth.json';
import cz from '@translations/cz/auth.json';
import fr from '@translations/fr/auth.json';
import gr from '@translations/gr/auth.json';
import it from '@translations/it/auth.json';
import pr from '@translations/pr/auth.json';
import ru from '@translations/ru/auth.json';
import sk from '@translations/sk/auth.json';
import sp from '@translations/sp/auth.json';
import tr from '@translations/tr/auth.json';
import hu from '@translations/hu/auth.json';
import { ITranslations } from '@/types/common';
import { AuthTransFields } from './types';

export const authTranslations: ITranslations<AuthTransFields> = {
  name: 'auth',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
